// extracted by mini-css-extract-plugin
export default {"main":"HtmlView_main__YFJIm"};